import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import Constants from '../Utils/TraductionFiles/Constants.js';
import Contrat from '../Utils/TraductionFiles/Contrat.js';
import Notifications from '../Utils/TraductionFiles/Notifications.js';
import ClientAO from './TraductionFiles/ClientAO.js';
import CompteClient from './TraductionFiles/CompteClient.js';
import CompteExpert from './TraductionFiles/CompteExpert.js';
import ConditionGeneral from './TraductionFiles/ConditionGeneral.js';
import Dashboards from './TraductionFiles/Dashboards.js';
import ExpertAO from './TraductionFiles/ExpertAO.js';
import HomeContent from './TraductionFiles/HomeContent.js';
import HomeContentS from './TraductionFiles/HomeContentS.js';
import Langues from './TraductionFiles/Langues.js';
import Messages from './TraductionFiles/Messages.js';
import OtherContent from './TraductionFiles/OtherContent.js';
import PolitiqueConfidentialite from './TraductionFiles/PolitiqueConfidentialite.js';
import TableContent from './TraductionFiles/TableContent.js';
import TableContentS from './TraductionFiles/TableContentS.js';
// doc off : https://www.npmjs.com/package/react-i18next
// https://betterprogramming.pub/add-multi-language-support-in-react-js-a771c9ab31c3
// https://www.mindbowser.com/adding-multi-language-support-using-reactjs/
// https://react.i18next.com/latest/using-with-hooks
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    // we init with resources
        resources: {

            fr: {
                translations: {
                    ...Constants.fr,
                    ...Contrat.fr,
                    ...Notifications.fr,
                    ...CompteExpert.fr,
                    ...ClientAO.fr,
                    ...PolitiqueConfidentialite.fr,
                    ...ExpertAO.fr,
                    ...Dashboards.fr,
                    ...ConditionGeneral.fr,
                    ...CompteClient.fr,
                    ...OtherContent.fr,
                    ...TableContentS.fr,
                    ...TableContent.fr,
                    ...HomeContentS.fr,
                    ...HomeContent.fr,
                    ...Langues.fr,
                    ...Messages.fr,
                }
            },
            en: {
                translations: {
                    ...Constants.en,
                    ...Contrat.en,
                    ...Notifications.en,
                    ...CompteExpert.en,
                    ...ClientAO.en,
                    ...PolitiqueConfidentialite.en,
                    ...ExpertAO.en,
                    ...Dashboards.en,
                    ...ConditionGeneral.en,
                    ...CompteClient.en,
                    ...OtherContent.en,
                    ...TableContentS.en,
                    ...TableContent.en,
                    ...HomeContentS.en,
                    ...HomeContent.en,
                    ...Langues.en,
                    ...Messages.en,
                }
            },
        },
        fallbackLng: 'fr',
        lng: 'fr',
        debug: false,

        // have a common namespace used around the full app
        ns: ['translations'],
        defaultNS: 'translations',

        keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;